import { useEffect, useRef, useState } from 'react'

export const useInputFocus = () => {
  const [isFocused, setIsFocused] = useState<boolean>(false)

  const inputRef = useRef<HTMLInputElement>(null)

  useEffect(() => {
    const handleFocusIn = () => setIsFocused(true)
    const handleFocusOut = () => setIsFocused(false)

    inputRef.current?.addEventListener('focusin', handleFocusIn)
    inputRef.current?.addEventListener('focusout', handleFocusOut)

    return () => {
      inputRef.current?.removeEventListener('focusin', handleFocusIn)
      inputRef.current?.removeEventListener('focusout', handleFocusOut)
    }
  }, [])

  return { isFocused, inputRef }
}
